import React from 'react';
import { TICKER } from '../../data/smaken';
const BAND = [...TICKER, ...TICKER];
export function Ticker() {
  return <div className="overflow-hidden border-y border-black bg-blaa py-3 text-papper" aria-hidden="true" data-id="element-679" data-mp="8lqqxeg06ihr">
      <div className="flex w-max animate-drift" data-id="element-680" data-mp="na3nacj063cs">
        {BAND.map((word, i) => <span key={`${word}-${i}`} className="whitespace-nowrap px-6 text-[12px] font-bold uppercase tracking-wide3" data-id="element-681" data-mp="ihkbnl3vliam" data-mpi={i}>
            {word}
            <span className="pl-6 text-smor" data-id="element-682" data-mp="s8y6vgosnvxy">✳</span>
          </span>)}
      </div>
    </div>;
}